<template>
  <div class="flex items-center gap-1">
    <button
      :content="factorName"
      v-tippy="{ arrow: true, theme: 'green' }"
      class="btn"
      :class="{
        selected: value === 'factor',
      }"
      @click="$emit('input', 'factor')"
      :disabled="disabled"
    >
      <div class="rotate-45 transform">
        <i v-html="$icons.percent"></i>
      </div>
    </button>
    <button
      :content="'Percentual'"
      v-tippy="{ arrow: true, theme: 'green' }"
      class="btn"
      :class="{
        selected: value === 'percent',
      }"
      @click="$emit('input', 'percent')"
      :disabled="disabled"
    >
      <i v-html="$icons.percent"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    method: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },

  computed: {
    factorName() {
      switch (this.method) {
        case "Função linear":
          return "Resíduo";
        case "Fator":
          return "Fator";
        case "Diferença":
          return "Diferença";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  @apply rounded;
}
.selected {
  @apply ring-ontick-blue-600 text-ontick-blue-600 ring-1;
}
</style>
